import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/index.scss'
// import '@/assets/js/libs/jquery-3.4.1.min.js'
// import '@/assets/js/libs/jquery-scrollto.min.js'
import $ from 'jquery'
import scrollTo from 'jquery.scrollto'
import '@/assets/js/set-font-size.js'
$.scrollTo = scrollTo
Vue.config.productionTip = false

//路由相关
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = '';
    // 如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to) => {
  if (to.meta.title) {
    // 如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
